import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommercePerformanceReportOrdersAction from '../actions/ecommerce-performance-report.action';
import * as EcommercePerformanceReportOrdersLastYearAction from '../actions/ecommerce-performance-report-last-year.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommercePerformanceReportOrders} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";
import {LoadEcommercePerformanceReportOrdersLastYear} from "../actions/ecommerce-performance-report-last-year.action";
@Injectable()
export class EcommercePerformanceReportEffect {

  loadEcommercePerformanceReportOrders = createEffect(() => this._actions$.pipe(
    ofType(EcommercePerformanceReportOrdersAction.LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS),
    mergeMap((action: LoadEcommercePerformanceReportOrders) => {
      const {websiteId} = action.payload;
      const datePicker = action?.payload?.datePicker;
      const forceCharge = action?.payload?.forceCharge;
      return this._ecommerceService.getPerformanceReportOrders(websiteId, datePicker, forceCharge)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommercePerformanceReportOrdersAction.LoadEcommercePerformanceReportOrdersSuccess({
                ordersData: response?.data?.dataKey?.intervals,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommercePerformanceReportOrdersAction.LoadEcommercePerformanceReportOrdersFail({websiteId});
          })
        );
    })
  ));

  loadEcommercePerformanceReportOrdersLastYear = createEffect(() => this._actions$.pipe(
    ofType(EcommercePerformanceReportOrdersLastYearAction.LOAD_ECOMMERCE_PERFORMANCE_REPORT_ORDERS_LAST_YEAR),
    mergeMap((action: LoadEcommercePerformanceReportOrdersLastYear) => {
      const {websiteId} = action.payload;
      const datePicker = action?.payload?.datePicker;
      const forceCharge = action?.payload?.forceCharge;
      return this._ecommerceService.getPerformanceReportOrders(websiteId, datePicker, forceCharge)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommercePerformanceReportOrdersLastYearAction.LoadEcommercePerformanceReportOrdersLastYearSuccess({
                ordersDataLastYear: response?.data?.dataKey?.intervals,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommercePerformanceReportOrdersLastYearAction.LoadEcommercePerformanceReportOrdersLastYearFail({websiteId});
          })
        );
    })
  ));


  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
